/* Frenly Bricks mobile product gallery pagination dots (CardsHQ style).
   Hooks into Dawn's existing media-gallery / slider-component instead of
   tracking swipe position itself: assets/global.js's SliderComponent
   dispatches a `slideChanged` event (with the now-current slide element in
   `event.detail.currentElement`) whenever the gallery's native scroll
   position settles on a new slide -- covering swipe, arrow-button, and
   thumbnail-driven navigation alike. See assets/media-gallery.js for the
   `media-gallery` custom element this reads `data-media-id` and
   `setActiveMedia()` from. */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var mobileMedia = window.matchMedia(MOBILE_QUERY);

  function buildDots(slides) {
    var dots = document.createElement('div');
    dots.className = 'fb-gallery-dots';
    // These navigate the existing gallery, not a separate tabpanel widget.
    // Native buttons retain Enter/Space and ordinary sequential keyboard focus.
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', 'Product images');

    slides.forEach(function (slide, index) {
      var mediaId = slide.getAttribute('data-media-id');
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'fb-gallery-dots__dot';
      dot.dataset.mediaId = mediaId || '';
      dot.setAttribute('aria-label', 'Show image ' + (index + 1) + ' of ' + slides.length);
      var isActive = slide.classList.contains('is-active');
      if (isActive) dot.classList.add('is-active');
      dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      dots.appendChild(dot);
    });

    return dots;
  }

  function setActiveDot(dots, mediaId) {
    var buttons = dots.querySelectorAll('.fb-gallery-dots__dot');
    for (var i = 0; i < buttons.length; i++) {
      var isActive = buttons[i].dataset.mediaId === mediaId;
      buttons[i].classList.toggle('is-active', isActive);
      buttons[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
    }
  }

  function init(gallery) {
    if (!gallery || gallery.dataset.fbDotsReady === 'true') return;

    // Skip the desktop-only duplicate gallery instance rendered by
    // snippets/product-media-gallery.liquid (`is_duplicate: true`, id
    // suffixed "-duplicate"). It's hidden on mobile (`small-hide`) and is
    // never the gallery a mobile shopper actually swipes through.
    if (/-duplicate$/.test(gallery.id)) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    if (slides.length < 2) return;

    var viewer = gallery.querySelector('slider-component');
    if (!viewer) return;

    gallery.dataset.fbDotsReady = 'true';

    var dots = buildDots(slides);
    var thumbSlider = gallery.querySelector('.thumbnail-slider');
    if (thumbSlider) {
      gallery.insertBefore(dots, thumbSlider);
    } else {
      gallery.appendChild(dots);
    }

    dots.addEventListener('click', function (event) {
      var dot = event.target.closest('.fb-gallery-dots__dot');
      if (!dot || !dot.dataset.mediaId) return;
      // Update the active dot immediately on click rather than waiting on
      // `slideChanged` -- that event only fires from the viewer's own
      // scroll listener, and setActiveMedia() doesn't reliably trigger a
      // scroll in every gallery layout (e.g. when there's nothing to
      // scroll to because the target slide is already positioned at 0).
      // This mirrors how media-gallery.js keeps its own thumbnail active
      // state in sync: synchronously in setActiveMedia(), not only via the
      // event.
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(dot.dataset.mediaId, false);
        setActiveDot(dots, dot.dataset.mediaId);
      }
    });

    viewer.addEventListener('slideChanged', function (event) {
      var currentElement = event.detail && event.detail.currentElement;
      if (!currentElement) return;
      var mediaId = currentElement.getAttribute('data-media-id');
      if (mediaId) setActiveDot(dots, mediaId);
    });
  }

  function boot(scope) {
    if (!mobileMedia.matches) return;
    var root = scope || document;
    var galleries = root.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) init(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  // A page opened at desktop width must initialise when zooming or resizing
  // into the mobile layout. Existing gallery guards prevent duplicate controls.
  function onBreakpointChange() { boot(document); }
  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', onBreakpointChange);
  } else if (typeof mobileMedia.addListener === 'function') {
    mobileMedia.addListener(onBreakpointChange);
  }
})();
